import { z } from "zod";

// Remote app config served by `GET /app-config` (public, unauthenticated) and
// consumed by the mobile gate to drive the force-update / maintenance screens.
//
//   • minVersion        — lowest supported semver; if the running app is below
//                          it, the worker app shows a hard force-update gate.
//                          null = no minimum (never force update).
//   • maintenance        — when true, the app shows a full-screen maintenance
//                          block for everyone.
//   • maintenanceMessage — optional custom copy for the maintenance screen.
//   • iosUpdateUrl /     — store links the force-update CTA opens. null falls
//     androidUpdateUrl     back to the app's built-in default per platform.
export const appConfigSchema = z.object({
  minVersion: z.string().nullable(),
  maintenance: z.boolean(),
  maintenanceMessage: z.string().nullable(),
  iosUpdateUrl: z.string().nullable(),
  androidUpdateUrl: z.string().nullable(),
});
export type AppConfig = z.infer<typeof appConfigSchema>;

// Admin patch — every field optional so callers can flip one switch at a time.
export const appConfigUpdateSchema = z.object({
  minVersion: z.string().nullable().optional(),
  maintenance: z.boolean().optional(),
  maintenanceMessage: z.string().nullable().optional(),
  iosUpdateUrl: z.string().nullable().optional(),
  androidUpdateUrl: z.string().nullable().optional(),
});
export type AppConfigUpdateRequest = z.infer<typeof appConfigUpdateSchema>;
